import axios from '@liepin/cnpm-js-axios-fe';
import qs from 'qs';

// 统一规范，使用 __LP_VERSION
window.__FE_CLIENT_ID = '40247';
// window.__LP_CLIENT_ID
window.__FE_VERSION = '20220426';

const ajax = axios.create({
  timeout: 30000,
  withCredentials: true,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
  transformRequest: [
    data => {
      return qs.stringify(data)
    }
  ],
});

ajax.interceptors.response.use(
  response => {
    const { flag, msg, code } = response.data
    if (flag !== 1) {
      switch (code) {
        case 302:
        case 301:
        case 404:
          history.push('/notFound404');
          break;
        case 500:
        default:
      }
      //msg && message.warning(msg, 8);
    }
    return response.data;
  },
  error => {
    return Promise.reject(error);
  }
)

export default ajax;